import { Injectable } from '@angular/core';
import { RestService, Rest, ABP } from '@abp/ng.core';
import { TerminalManagement } from '../models';
import { Observable } from 'rxjs';
import { TerminalLog } from '../models';


@Injectable({
    providedIn: 'root',
})
export class TerminalLogService {

    apiName = 'TerminalManagement';
    constructor(private restService: RestService) { }

    getTerminalLogs(body: TerminalLog.TerminalLogListRequest): Observable<TerminalLog.TerminalLogReponse> {

        const request: Rest.Request<TerminalLog.TerminalLogListRequest> = {
            method: 'POST',
            url: '/api/TerminalManagement/TerminalLog/list',
            body,
        };

        return this.restService.request<TerminalLog.TerminalLogListRequest, TerminalLog.TerminalLogReponse>(request, { apiName: this.apiName });
    }

    delete(id: string) {
        const request: Rest.Request<null> = {
            method: 'DELETE',
            url: `/api/TerminalManagement/TerminalLog/${id}`,
        };
        return this.restService.request<null, null>(request, { apiName: this.apiName });
    }
}